(function() {
    'use strict';

    angular
        .module('bhsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('mentions', {
           parent: 'bhs',
            url: '/mentions-legales',
            data: {
                authorities: []
            },
            views: {
                'content@bhs': {
                    templateUrl: 'app/mentions/mentions.html',
                    controller: 'MentionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('mentions');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
